import {connect} from 'react-redux';
import {updatePreferences} from '../actionCreators/preferences';
import {findSection, updateSectionValue} from '../ducks/reportSections';
import CustomiseComparableListings from './CustomiseComparableListings';
import actionCreators from '../actionCreators';

const mapStateToProps = (state) => {
  const {reportSections, reportType: {value: reportTypeValue}, comparableListings} = state;
  return {
    section: findSection(reportSections, reportTypeValue, 'COMPARABLE_LISTINGS'),
    reportType: reportTypeValue,
    selectedComparableListings: comparableListings.selected.filter(id => !comparableListings.featured.includes(id)),
    featuredProperties: comparableListings.selected.filter(id => comparableListings.featured.includes(id)),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    sendEvent: (section, title) => {
      dispatch(actionCreators.sendEditTitleAnalyticsEvent(section, title));
    },
    updateValue: (value, dataKeyPath, reportType) => {
      dispatch(updateSectionValue({value, reportType, key: 'COMPARABLE_LISTINGS', dataKeyPath: `sectionData.${dataKeyPath}`}));
    },
    updatePreferences: (preferences, reportType) => {
      dispatch(updatePreferences(preferences, reportType));
    }
  };
};

const mergeProps = (stateProps, dispatchProps) => {
  return {
    ...stateProps,
    ...dispatchProps,
    updateSectionValue: (value, dataKeyPath) => {
      dispatchProps.updateValue(value, dataKeyPath, stateProps.reportType);
      dispatchProps.sendEvent(stateProps.section, value);
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(CustomiseComparableListings);
